import styled from 'styled-components';
import { default as MaterialBox } from '@material-ui/core/Box';

export const Box = styled(MaterialBox)`
    width: 100%;
    padding: 16px 24px 24px 24px;
    background: #fff;
    box-shadow: none;
    border-radius: 8px;
    border: 1px solid rgb(223, 224, 235);

    &:not(:last-child) {
        margin-bottom: 16px;
    }
`;

export const BoxTitle = styled.p`
    font-size: 18px;
    font-weight: bold;
    line-height: 26px;
    margin: 0px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const BoxContent = styled.div`
    div {
        display: flex;
        line-height: 3rem;

        & > span:first-child {
            flex-shrink: 0;
            flex-basis: 160px;
            color: #252733;

            text-transform: capitalize;
        }

        & > span:last-child {
            color: #9fa2b4;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    img {
        width: 100%;
        height: auto;
    }
`;
